import React, { useState } from 'react';
import { Col, Row } from '../../../lib/utils';
import { CaptionBold, CaptionLight, Body3Bold } from '../../../lib/font';
import dayjs from 'dayjs';
import GroupSessionHoverCard from '../GroupSessionHoverCard';

const CLASS_TYPE_COLORS: Record<string, { border: string; bg: string; text: string }> = {
    GROUP: { border: '#10B981', bg: '#ECFDF5', text: '#065F46' },
    PRIVATE_1ON2: { border: '#3B82F6', bg: '#EFF6FF', text: '#1E40AF' },
    PRIVATE_1ON3: { border: '#8B5CF6', bg: '#F5F3FF', text: '#5B21B6' },
};

const CLASS_TYPE_LABEL: Record<string, string> = {
    GROUP: '그룹',
    PRIVATE_1ON2: '1:2',
    PRIVATE_1ON3: '1:3',
};

const GroupSessionBlock = ({
    onClickSchedule,
    parentItem,
    parentIndex,
    childItem,
    colPosition,
    rowPosition,
    boxHeight,
}: any) => {
    const [isHover, setIsHover] = useState(false);
    const classType = childItem.classType || 'GROUP';
    const colorCfg = CLASS_TYPE_COLORS[classType] || CLASS_TYPE_COLORS.GROUP;
    const isOngoing = dayjs().isAfter(childItem.startTime) && dayjs().isBefore(childItem.endTime);

    // hover 카드 위치는 기존 PT 블록과 동일한 규칙 (오른쪽 강사 칸은 왼쪽으로 펼침)
    const hoverStyle = parentIndex > 5 ? { right: '110%' } : { left: '110%' };

    return (
        <Col
            onClick={() => onClickSchedule(childItem)}
            style={{
                width: '10.4%',
                height: boxHeight,
                position: 'absolute',
                marginTop: colPosition,
                marginLeft: `${rowPosition}%`,
                borderRadius: 6,
                border: `2px solid ${colorCfg.border}`,
                backgroundColor: colorCfg.bg,
                cursor: 'pointer',
                boxShadow: isHover ? `0 0 12px ${colorCfg.border}40` : 'none',
                transition: 'box-shadow 0.15s',
            }}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            {/* 블록 본문만 잘라내고, hover 카드는 바깥에 두어 클리핑되지 않게 한다 */}
            <Col
                style={{
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'start',
                    paddingLeft: '1%',
                    paddingRight: '1%',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                }}
            >
                {/* 상단: 수업명 + 타입 뱃지 */}
                {childItem?.duration > 15 ? (
                    <Row style={{ alignItems: 'center', gap: 4, width: '100%' }}>
                        <Body3Bold style={{ color: colorCfg.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                            {childItem?.title || childItem?.alias || '그룹 수업'}
                        </Body3Bold>
                    </Row>
                ) : (
                    <CaptionBold style={{ color: colorCfg.text }}>
                        {childItem?.title || childItem?.alias || '그룹'}
                    </CaptionBold>
                )}

                {/* 인원 표시 */}
                {childItem?.duration > 20 && (
                    <Row style={{ alignItems: 'center', gap: 4 }}>
                        <CaptionLight style={{ color: colorCfg.text, opacity: 0.8 }}>
                            {childItem?.currentCount ?? 0}/{childItem?.maxCapacity ?? '?'}명
                        </CaptionLight>
                        <span style={{
                            fontSize: 10,
                            padding: '1px 5px',
                            borderRadius: 3,
                            backgroundColor: `${colorCfg.border}20`,
                            color: colorCfg.text,
                            fontWeight: 600,
                        }}>
                            {CLASS_TYPE_LABEL[classType]}
                        </span>
                    </Row>
                )}

                {/* 시간 */}
                {childItem?.duration > 30 && (
                    <CaptionLight style={{ color: colorCfg.text, opacity: 0.6, fontSize: 10 }}>
                        {dayjs(childItem.startTime).format('HH:mm')}~{dayjs(childItem.endTime).format('HH:mm')}
                    </CaptionLight>
                )}
            </Col>

            {/* 진행중 표시 */}
            {isOngoing && (
                <div style={{
                    position: 'absolute',
                    top: 2,
                    right: 4,
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: colorCfg.border,
                }} />
            )}

            {isHover && (
                <GroupSessionHoverCard item={childItem} style={hoverStyle} accentColor={colorCfg.border} />
            )}
        </Col>
    );
};

export default GroupSessionBlock;
